// =====================================================================
// Convoyeur/styles.js — styles + helpers partagés du module Convoyeur
// =====================================================================
// Repris 1:1 des constantes de style Zeus Log (cf. Trajets.jsx) pour que
// le module ait EXACTEMENT le même look (tabs, boutons, tableaux).
// =====================================================================

export const inputBase = {
  padding: '0.4rem 0.5rem',
  border: '1px solid #d1d5db',
  borderRadius: 4,
  fontSize: '0.8125rem',
  background: '#fff',
};

export const btnPrimary = {
  background: '#2563eb', color: '#fff', border: 0,
  padding: '0.5rem 1rem', borderRadius: 4,
  fontWeight: 500, fontSize: '0.875rem', cursor: 'pointer',
};

export const btnSuccess = {
  background: '#059669', color: '#fff', border: 0,
  padding: '0.5rem 1rem', borderRadius: 4,
  fontWeight: 500, fontSize: '0.875rem', cursor: 'pointer',
};

export const btnGhost = {
  background: 'transparent', color: '#374151',
  border: '1px solid #d1d5db', borderRadius: 4,
  padding: '0.5rem 0.875rem', fontWeight: 500, fontSize: '0.8125rem', cursor: 'pointer',
};

export const thStyle = {
  padding: '0.625rem 0.75rem',
  fontSize: '0.6875rem',
  fontWeight: 600,
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  textAlign: 'left',
  borderBottom: '1px solid #e5e7eb',
};

export const tdStyle = {
  padding: '0.625rem 0.75rem',
  verticalAlign: 'middle',
  color: '#374151',
  fontSize: '0.875rem',
};

export const tabBtn = (active) => ({
  background: 'transparent',
  border: 0,
  padding: '0.75rem 1.25rem',
  fontSize: '0.875rem',
  fontWeight: active ? 600 : 400,
  color: active ? '#2563eb' : '#6b7280',
  borderBottom: active ? '2px solid #2563eb' : '2px solid transparent',
  cursor: 'pointer',
  marginBottom: -1,
});

// --- branding transporteurs (repris du panneau HMI zeus-pallets.js) ------
export const BRANDS = {
  'UPS':           { bg: '#351c15', fg: '#ffb500', t: 'UPS' },
  'GLS':           { bg: '#06168f', fg: '#ffd100', t: 'GLS' },
  'DHL':           { bg: '#ffcc00', fg: '#d40511', t: 'DHL' },
  'DHL Express':   { bg: '#ffcc00', fg: '#d40511', t: 'DHL Express' },
  'Bpost':         { bg: '#e5202e', fg: '#ffffff', t: 'bpost' },
  'DPD':           { bg: '#dc0032', fg: '#ffffff', t: 'DPD' },
  'Colissimo':     { bg: '#003a70', fg: '#ffffff', t: 'Colissimo' },
  'Mondial Relay': { bg: '#e2001a', fg: '#ffffff', t: 'Mondial Relay' },
  'Rejets':        { bg: '#7f1d1d', fg: '#fde68a', t: '⛔ Rejets' },
};

export function brandOf(c) {
  return BRANDS[c] || { bg: '#475569', fg: '#fff', t: c || '—' };
}

// petite pastille logo transporteur
export function CarrierChip({ carrier, small }) {
  const b = brandOf(carrier);
  return (
    <span style={{
      display: 'inline-block',
      background: b.bg, color: b.fg,
      fontWeight: 800, fontSize: small ? '0.6875rem' : '0.8125rem',
      borderRadius: 5, padding: small ? '1px 6px' : '3px 9px',
      lineHeight: 1.2, whiteSpace: 'nowrap', letterSpacing: '.2px',
      boxShadow: '0 1px 3px rgba(15,23,42,.22)',
    }}>{b.t}</span>
  );
}

// --- helpers format -------------------------------------------------------
export function fmtWeight(g) {
  if (g == null || isNaN(g)) return '—';
  return g >= 1000 ? `${(g / 1000).toFixed(2)} kg` : `${g} g`;
}

export function fmtDims(dims) {
  if (!Array.isArray(dims) || dims.every(d => !d)) return '—';
  return dims.map(d => d || 0).join(' × ') + ' cm';
}

// GRAV (sortie) -> libellé ligne L1..L7
export function lineLabel(lineNo, gravNo) {
  if (!lineNo) return '—';
  return `L${lineNo}${gravNo ? ` · ${gravNo}` : ''}`;
}

// "hors-ligne" = edge injoignable (503), route pas encore déployée (404),
// ou pas de réponse (réseau). On les traite tous comme hors-ligne pour
// dégrader proprement (soft-launch : backend pas encore redéployé).
export function isOfflineError(err) {
  const s = err?.response?.status;
  return !err?.response || s === 404 || s === 503;
}
